// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"13":"72754f94","272":"72b720d2","324":"1fdd43cc","460":"2bbe2e7c","660":"f19661b6","756":"dc61c045","872":"f90f49eb"}[chunkId] + ".css";
};